<template>
  <div>
    <notifications></notifications>
    <navbar :show-navbar="showMenu" type="white" :transparent="false">
      <div class="navbar-wrapper">
        <div class="navbar-toggle" :class="{ toggled: showMenu }">
          <navbar-toggle-button @click.native="toggleNavbar">
          </navbar-toggle-button>
        </div>
        <a class="navbar-brand" href="#"
        ><img
          src="img/logo1.png"
          width="45"
          alt=""
          class="d-inline-block align-middle mr-2"
        />
          <!-- Logo Text -->
          <span class="text-uppercase font-weight-bold"></span></a
        >
      </div>

      <!--
      <template slot="navbar-menu">
        <drop-down
          tag="li"
          position="right"
          class="nav-item"
          icon="now-ui-icons location_world"
          :title="$t('app.general.language') + ' | ' + lang"
        >
          <button class="dropdown-item" @click="changeLanguage('es')">
            {{ $t("app.languages.spanish") }}
          </button>
          <button class="dropdown-item" @click="changeLanguage('en')">
            {{ $t("app.languages.english") }}
          </button>
        </drop-down>

      </template>
      -->
    </navbar>
    <div class="wrapper wrapper-full-page">
      <div
        class="full-page section-image"
        :class="pageClass"
        filter-color="black"
      >
        <div class="content">
          <div class="row">
            <div class="col-4"></div>
            <div class="col-4">
              <div class="card">
                <div class="card-header" style="text-align: center; margin-bottom: 20px;">
                  <img src="img/logo1.png" alt="" style="width: 70px;"/>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-12" style="text-align: center;">
                      <label style="font-size: 13px; margin-bottom: 30px; text-align: justify; color: black">
                        {{ $t('app.modules.recover_pass.headers.text') }}
                      </label>
                      <ValidationObserver v-slot="{ handleSubmit }">
                        <form @submit.prevent="handleSubmit(changePass)">
                          <ValidationProvider
                            name="password"
                            rules="required|min:5"
                            v-slot="{ passed, failed }"
                          >
                            <fg-input
                              type="password"
                              :error="failed ? $t('app.general.required') : null"
                              :hasSuccess="passed"
                              class="no-border form-control-lg txt_login input"
                              :placeholder="$t('app.modules.recover_pass.headers.password')"
                              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                              v-model="password"
                            >
                            </fg-input>
                          </ValidationProvider>

                          <ValidationProvider
                            name="password_confirmation"
                            rules="required|confirmed:password"
                            v-slot="{ passed, failed }"
                          >
                            <fg-input
                              type="password"
                              :error="failed ? $t('app.general.password_confirm') : null"
                              :hasSuccess="passed"
                              class="no-border form-control-lg txt_login input"
                              :placeholder="$t('app.modules.recover_pass.headers.password_confirm')"
                              addon-left-icon="now-ui-icons ui-1_lock-circle-open"
                              v-model="password_confirm"
                            >
                            </fg-input>
                          </ValidationProvider>

                          <div slot="footer">
                            <div class="row">
                              <div class="col-12">
                                <n-button type="primary" native-type="submit" round block text-uppercase style="width: 100% !important; ">
                                  {{ $t('app.modules.recover_pass.buttons.change_pass') }}
                                </n-button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </ValidationObserver>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4"></div>
          </div>
        </div>

      </div>

    </div>
  </div>
</template>
<script>
import { Navbar, NavbarToggleButton } from "src/components";
import { mapState, mapMutations } from "vuex";
import {getResponse} from "@/util/utilities";

export default {
  components: {
    Navbar,
    NavbarToggleButton
  },
  computed: {
    ...mapState(["lang"])
  },
  props: {
    backgroundColor: {
      type: String,
      default: "black"
    }
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      pageClass: "login-page",
      password: "",
      password_confirm: "",
      token: ""
    };
  },
  mounted() {
    if (!!this.$route.params.token) {
      this.token = this.$route.params.token;
    }
  },
  methods: {
    ...mapMutations({
      setLang: "SET_LANG"
    }),
    async changePass(){
      if(this.token.length === 0){
        this.notifyMessage("danger", this.$t("app.modules.recover_pass.errors.no_token"));
        return;
      }

      let data = {
        Token: this.token,
        Contrasena: this.password
      };

      let request = await this.$http.post(route("Usuarios/changePassword"), data);
      let response = getResponse(request);

      if(response != null){
        this.$router.push({
          name: "Authentication"
        });
      }
      else this.notifyMessage("danger", this.$t("app.modules.recover_pass.errors.change_pass_failed"));
    },
    changeLanguage(value) {
      this.setLang(value);
      this.$root.$i18n.locale = value;
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
    setPageClass() {
      this.pageClass = `${this.$route.name}-page`.toLowerCase();
    },
    moveObject() {
      this.transitionClass = this.transitionClass.includes("show") ? "" : "show";
    }
  },
  beforeDestroy() {
    this.closeMenu();
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
  watch: {
    $route() {
      this.setPageClass();
    }
  }
};
</script>
<style lang="scss">
$scaleSize: 0.8;
@keyframes zoomIn8 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  100% {
    opacity: 1;
  }
}
.wrapper-full-page .zoomIn {
  animation-name: zoomIn8;
}
@keyframes zoomOut8 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.wrapper-full-page .zoomOut {
  animation-name: zoomOut8;
}
</style>
<style>
html {
  max-width: 100%;
  overflow-x: hidden;
}

body {
  background-color: #fafafa;
}

button {
  width: auto !important;
}

/*.content {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  height: 800px !important;
}*/

.footer {
  background-color: #1e1e1e;
}

.block {
  border-radius: 30px;
  background-color: #cecececc;
  padding: 20px 90px;
  height: 500px;
  width: 500px;
}

/*.content-login {
  height: 700px !important;
  padding-top: 65px;
}
.content-login .row {
  height: 100%;
}

.content-login .row .col-6 {
  height: 100%;
  width: 50%;
  display: inline-block;
}

.content-login .row .col-3 {
  height: 100%;
  width: 25%;
  display: inline-block;
}

.content-login .row .col-9 {
  height: 100%;
  width: 75%;
  display: inline-block;
}



.block {
  border-radius: 30px;
  background-color: #cecececc;
  padding: 20px 90px;
  height: 500px;
  width: 500px;
  opacity: 0;
  position: absolute;
  top: 10%;
  left: 100%;
  -webkit-transform: translate(-50%, 0%);
  -moz-transform: translate(-50 0%);
  transform: translate(-50%, 0%);
  -webkit-transition: 1200ms;
  -moz-transition: 1200ms;
  transition: 1200ms;
}

.block.show {
  opacity: 1;
  left: 50%;
}*/
</style>
